import { render, staticRenderFns } from "./CardsInfoEntradas.vue?vue&type=template&id=4e4cc0f0"
import script from "./CardsInfoEntradas.vue?vue&type=script&setup=true&lang=js"
export * from "./CardsInfoEntradas.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports